import styled from 'styled-components';

export const SaveActionsWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  width: 90px;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: -ms-grid;
    -ms-grid-columns: auto auto;
  }
`;
